import * as types from '../mutations'
import CertificateService from '@/services/CertificateService'

const state = {
  certificates: []
}

const getters = {
  getCertificatesForLocation: (state) => (locationId) => {
    if (!state.certificates.length) {
      return {}
    }

    return state.certificates.filter((certificate) => {
      return certificate.location === locationId
    })
  }
}

const actions = {

  async updateCertificate ({ commit }, { certificate }) {
    let res = await CertificateService.updateCertificate(certificate)
    commit(types.CERTIFICATE_UPDATED, res)
  },

  async createCertificate ({ commit }, { certificate }) {
    let res = await CertificateService.createCertificate(certificate)
    commit(types.CERTIFICATE_CREATED, res)
  },

  async loadCertificates ({ commit }) {
    let certificates = await CertificateService.loadCertificates()
    commit(types.SET_CERTIFICATES_LIST, certificates)
  }

}

const mutations = {

  [types.CERTIFICATE_UPDATED] (state, certificate) {
    state.certificates = [
      ...state.certificates.filter(c => c.id !== certificate.id),
      certificate
    ]
  },

  [types.SET_CERTIFICATES_LIST] (state, certificates) {
    state.certificates = certificates
  },

  [types.CERTIFICATE_CREATED] (state, certificate) {
    state.certificates.push(certificate)
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
